export default "__VITE_ASSET__29c9d422__"